import * as React from "react"
import {Display} from "../../components/Display";
import {Icon, icons, Tooltip} from "@vebox/etui-core";
import {ETUI_ICONS_SIZE} from "../UserManagement";
import {StyleProps} from "@vebox/etui-system";

interface SearchIconProps {
    showHideSearchBar: () => void
    openSearchBarMessage?: string
    closeSearchBarMessage?: string
}

export const CLOSE_ICON: { root: StyleProps } = {
    root: {
        width: 12,
        height: 12,
        position: "absolute",
        top: "15px",
        right: "12px",
        zIndex: 1
    }
};

export const SearchIcon: React.FC<SearchIconProps> = (
    {showHideSearchBar, closeSearchBarMessage, openSearchBarMessage}
) => {
    const [showSearchRoleBar, setShowSearchRoleBar] = React.useState<boolean>(false);

    const showHide = () => {
        setShowSearchRoleBar(prevState => !prevState);
        showHideSearchBar()
    }

    return <>
        <Display isVisible={!showSearchRoleBar}>
            <Tooltip
                disableToolTip={!openSearchBarMessage}
                message={openSearchBarMessage}
                placement={"left"}
            >
                <span
                    className="clickable"
                    onClick={showHide}
                ><Icon glyph={icons.SEARCH} size={ETUI_ICONS_SIZE}/></span>
            </Tooltip>
        </Display>
        <Display isVisible={showSearchRoleBar}>
            <Tooltip
                disableToolTip={!closeSearchBarMessage}
                message={closeSearchBarMessage}
                placement={"left"}
            >
                <span
                    className="clickable"
                    onClick={showHide}
                >
                    <Icon
                        glyph={icons.CLOSE}
                        styles={CLOSE_ICON}
                    />
                    <Icon glyph={icons.SEARCH} size={ETUI_ICONS_SIZE}/>
                </span>
            </Tooltip>
        </Display>
    </>
}